export const FETCH_SHOP_DETAIL = "FETCH_SHOP_DETAIL"
export const FETCH_HQ_SHOP_DETAIL = "FETCH_HQ_SHOP_DETAIL"
export const FETCH_SHOP_LIST = "FETCH_SHOP_LIST"


//LINK
export const SET_LINK_INVENTORY = "SET_LINK_INVENTORY"
export const SET_LINK_SETTING = "SET_LINK_SETTING"

